import {cx} from '@local/utils/cx'
import type {ElementType, ReactNode} from 'react'

export interface SmallTextProps {
	children: ReactNode
	className?: string
	textColor?: 'white' | 'grey-1' | 'grey-2' | 'black'
	as?: ElementType
}

export const SmallText = ({children, className, textColor = 'grey-2', as = 'p'}: SmallTextProps) => {
	const Tag = as
	return (
		<Tag className={cx(
			'font-medium uppercase tracking-widest leading-tight text-grey-2',
			textColor === 'white' && 'text-white',
			textColor === 'grey-1' && 'text-grey-1',
			textColor === 'grey-2' && 'text-grey-2',
			textColor === 'black' && 'text-black',
			className,
			'text-9',
		)}>
			{children}
		</Tag>
	)
}
